<template>
  <v-container class="pa-0">
    <h3 class="mb-3">Edit Resource</h3>
    <hr class="thick" />
    <v-form ref="uploadForm" v-model="form.valid">
      <amaze-editor
        v-model="card.card_resource[0].description"
        :rules="form.description"
        label="Edit the comment about the resource*:"
      ></amaze-editor>
      <v-btn color="primary" @click="editCard()" class="ml-0">Save Edits</v-btn>
      <v-btn @click="returnToGroup()" flat outline>Cancel and Close</v-btn>
    </v-form>
  </v-container>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
.resourceBox {
  background-color: $amaze-yellow-background;
}
::v-deep form {
  .v-input__slot {
    label {
      font-size: 15px;
      line-height: 1.5em;
      font-weight: bolder;
    }
  }
}
</style>

<script>
import { EventBus } from "@/components/Events/event-bus.js";
import cardCrudMixin from "@/mixins/cardCrudMixin.js"

export default {
  mixins: [cardCrudMixin],
  data() {
    return {
      card: {
        card_resource: [{ description: "" }]
      },
      form: {
        valid: false,
        description: [v => !!v || "This is a required field."]
      }
    };
  },
  methods: {
    editCard() {
      if (this.$refs.uploadForm.validate()) {
        const groupId = this.$route.params.id;

        this.$http.put("cards/" + this.card.id, this.card).then(
          response => {
            EventBus.$emit("refresh-cards", groupId, true);
            this.returnToGroup();
          },
          response => {
            console.log("Error updating card.");
          }
        );
      } else {
        this.$store.commit("updateMessage", {
          message:
            "Nice try, but some required information is missing. Give it another go!",
          snackbar: true
        });
      }
    }
  },
  mounted() {
    const returnRoute = "/group/" + this.$route.params.id + "/card/" + this.$route.params.card_id;
    this.$emit('setReturnRoute', returnRoute);
    this.$http.get("cards/" + this.$route.params.card_id).then(
      response => {
        this.card = response.body.data;
      },
      response => {
        console.log("Error getting card.");
      }
    );
  }
};
</script>
